<template>
  <div class="c-nodata" v-if="nodata">
    <i class="el-icon-folder-opened" style="font-size: 92px; color: #efefef"></i>
  </div>
  <div class="c-select-box" v-else>
    <div v-if="!noSelectAll" class="c-check-all" :class="{ 'c-check-item-disable': someDisabled }">
      <div class="c-item-select c-cataract" @click="selectAll"></div>
      <el-checkbox class="c-check-item" :disabled="someDisabled" v-model="all">全选</el-checkbox>
    </div>
    <div v-for="item in drops" :key="item.id">
      <el-checkbox class="c-check-item" v-model="item.check" :disabled="curDisabled(item)" @change="selectCheck($event, item)">{{
        item.value
      }}</el-checkbox>
    </div>
  </div>
</template>
<script>
import { isEmpty, trim, isArray } from '@/common/js/utils'

export default {
  name: 'selectBox',
  props: {
    filter: {
      type: Object,
      default: () => {
        return {
          keyword: '',
          gameGroupId: '',
          midGameId: ''
        }
      }
    },
    data: {
      type: Array
    },
    disabled: {
      type: Boolean,
      default: false
    },
    enableSelectAll: {
      type: Boolean,
      default: false
    },
    noSelectAll: {
      type: Boolean
    }
  },
  computed: {
    all() {
      const len = this.filterResult.filter((ret) => ret.check).length
      return this.filterResult.length === len
    },
    drops() {
      return this.filterResult.slice(0, 500)
    },
    filterResult() {
      let result = this.data
      // 过滤数据
      if (this.filter) {
        const { keyword, gameGroupId, midGameId } = this.filter
        if (!isEmpty(keyword)) {
          result = result.filter((ret) => ret.name && ret.name.toUpperCase().includes(trim(keyword).toUpperCase()))
        }
        if (!isEmpty(gameGroupId)) {
          result = result.filter((ret) => isArray(ret.gameGroupIds) && ret.gameGroupIds.includes(gameGroupId))
        }
        if (!isEmpty(midGameId)) {
          result = result.filter((ret) => ret.midGameId && ret.midGameId === midGameId)
        }
      }
      return result
    },
    nodata() {
      const no = Boolean(this.drops.length)
      return !no
    },
    curDisabled() {
      return (box) => {
        return this.disabled || box.disabled
      }
    },
    someDisabled() {
      return !this.enableSelectAll && (this.disabled || this.data.some((ret) => ret.disabled))
    }
  },
  methods: {
    selectAll() {
      if (this.someDisabled) return
      const num = this.data.filter((ret) => ret.check).length
      this.$emit('on-select', {
        filterResult: this.filterResult.filter((ret) => !ret.check === !this.all).slice(0, 1000 - num),
        check: !this.all,
        keyword: this.keyword
      })
    },
    selectCheck(val, item) {
      if (val) this.$set(item, '_time', Date.now()) // 用于排序
      this.$emit('on-checked', {
        key: item.key,
        name: item.value,
        check: val
      })
    }
  },
  watch: {
    data: {
      handler(nVal, oVal) {
        // computeChild(nVal, this)
      },
      deep: true
    }
  },
  mounted() {
    // computeChild(this.data, this)
  }
}
</script>
<style lang="scss" scoped>
.c-nodata {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.c-cataract {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 8;
  cursor: pointer;
}

.c-check-all {
  width: 100%;
  height: 36px;
  position: relative;
  z-index: 9;

  &:hover {
    .c-check-item {
      background-color: #f8f8f8;
    }
  }

  .c-item-select {
    width: 100%;
    height: 100%;
  }
}

.c-check-item {
  margin: 0;
  padding: 0 12px;
  display: block;
  position: relative;
  height: 36px;
  line-height: 36px;

  &:hover {
    background-color: #f8f8f8;
  }

  &.active {
    color: #598fe6;
    background-color: #f8f8f8;

    .c-check-arrow {
      color: #598fe6 !important;
    }
  }

  .c-check-arrow {
    float: right;
    margin-top: 10px;
  }

  .c-item-checkbox {
    width: 36px;
    height: 36px;
  }

  ::v-deep .el-checkbox {
    margin-right: 4px;
  }
}

.c-select-box {
  overflow: hidden;
  border-width: 0 !important;

  ::v-deep .el-checkbox__input.is-indeterminate {
    .el-checkbox__inner {
      background-color: #6fb3fb;
      border-color: #6fb3fb;
    }
  }
}

.c-check-item-disable {
  cursor: not-allowed;

  .c-cataract {
    cursor: not-allowed;
  }

  ::v-deep .el-checkbox__inner {
    background-color: #f3f3f3;
  }
}
</style>
